import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-images_style_3",
  "use": "icon-images_style_3-usage",
  "viewBox": "0 0 20 20.001",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20.001\" id=\"icon-images_style_3\">\r\n  <path id=\"icon-images_style_3_联合_72\" data-name=\"联合 72\" class=\"cls-1\" d=\"M20,20H0V0H20V20h0ZM1.176,18.823H18.823V13.53H1.176Zm17.647-6.471V7.647H1.176v4.705Zm0-5.882V1.176H1.176V6.47Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol